module.exports = __webpack_public_path__ + "media/images/flags/32/Thailand-ef14d4faebb7eacf5dd96001d4c8c1fa.png";